import React, { useContext, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import AuthContext from '../context/AuthContext';
import ProjectContext from '../context/ProjectContext';

// Components
import ProjectForm from '../components/projects/ProjectForm';
import OrganizationForm from '../components/projects/OrganizationForm';
import MemberAssignmentForm from '../components/projects/MemberAssignmentForm';
import ProjectList from '../components/projects/ProjectList';
import EditProjectModal from '../components/projects/EditProjectModal';

// Hooks
import { useProjectManagement } from '../hooks/useProjectManagement';

const ProjectManagement = ({ sharedUsers, sharedOrgs, fetchOrgs, onAssignOrg }) => {
  const { user } = useContext(AuthContext);
  const { projects, fetchProjects, updateProject } = useContext(ProjectContext);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  
  const { 
    users, 
    createProject, 
    assignMember 
  } = useProjectManagement(user, fetchProjects, sharedUsers);

  if (user?.type !== 'admin') return <div className="p-5 text-center">Access Denied</div>;

  const handleOpenEdit = (project) => {
    setEditingProject(project);
    setShowEditModal(true);
  };

  const handleEditSubmit = async (formData) => {
    if (editingProject) {
      const success = await updateProject(editingProject._id, formData);
      if (success) {
        setShowEditModal(false);
        setEditingProject(null);
      }
    }
  };

  return (
    <div>
      <h1 className="mb-4">Entity Management (Admin)</h1>
      
      <Row>
        <Col md={4}>
          <OrganizationForm onOrgCreated={fetchOrgs} />
        </Col>

        <Col md={4}>
          <ProjectForm onCreate={createProject} organizations={sharedOrgs} fetchOrgs={fetchOrgs} />
        </Col>

        <Col md={4}>
          <MemberAssignmentForm 
            projects={projects} 
            users={users} 
            onAssign={assignMember} 
            organizations={sharedOrgs}
            onAssignOrg={onAssignOrg}
          />
        </Col>
      </Row>

      <div className="mt-4">
        <h3 className="h5 mb-3 text-muted small text-uppercase font-weight-bold">Existing Companies & Access</h3>
        <ProjectList projects={projects} users={users} onEdit={handleOpenEdit} />
      </div>

      <EditProjectModal 
        show={showEditModal}
        onHide={() => {
          setShowEditModal(false);
          setEditingProject(null);
        }}
        onSubmit={handleEditSubmit}
        project={editingProject}
        organizations={sharedOrgs}
      />
    </div>
  );
};

export default ProjectManagement;
